export const PERMISSION_TYPE = {
    HIDDEN: 'hidden',
    VISIBLE: 'visible',
    READONLY: 'readonly'
}